import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/supplier-form-img.jpg")